import React, { useEffect, useState } from 'react';
import Masonry from 'react-masonry-css';
import { jsPDF } from 'jspdf';
import { Link } from 'react-router-dom';

function Admin() {
  const [mediaList, setMediaList] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [currentTitle, setCurrentTitle] = useState('');
  const [viewMode, setViewMode] = useState('cards');
  const [filter, setFilter] = useState('all');
  const [contributorFilter, setContributorFilter] = useState('');

  const breakpointColumnsObj = {
    default: 3,
    992: 2,
    768: 1
  };

  useEffect(() => {
    fetch('https://www.weavevo.com/media')
      .then(res => res.json())
      .then(data => setMediaList(data));
  }, []);

  const generateDoc = async (media) => {
    setCurrentTitle(media.title);
    const response = await fetch('https://www.weavevo.com/generate-doc', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ title: media.title, location: media.location })
    });

    const data = await response.json();
    setSelectedDoc(data.documentary);
    setShowModal(true);
  };

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text(currentTitle, 10, 20);
    doc.setFontSize(12);
    doc.text(selectedDoc, 10, 30);
    doc.save(`${currentTitle.replace(/\s+/g, '_')}_documentary.pdf`);
  };

  const getMediaType = (fileName) => {
    const ext = fileName.split('.').pop().toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return 'image';
    if (["mp4", "webm", "ogg"].includes(ext)) return 'video';
    return 'file';
  };

  const filteredMedia = mediaList.filter(media => {
    const type = getMediaType(media.file_path || media.location);
    const matchesType =
      (filter === 'videos' && type === 'video') ||
      (filter === 'images' && type === 'image') ||
      filter === 'all';
    const matchesContributor = contributorFilter ? media.contributor?.toLowerCase().includes(contributorFilter.toLowerCase()) : true;
    return matchesType && matchesContributor;
  });

  const filterOptions = [
    { id: 'all', label: 'Toutes les Épingles' },
    { id: 'videos', label: 'Vidéos' },
    { id: 'images', label: 'Images' }
  ];

  return (
    <div className="d-flex flex-column" style={{ paddingTop: '50px'}}>
      <div className="p-3 bg-white border-bottom d-flex flex-wrap justify-content-between align-items-center gap-3">
        <div className="d-flex flex-wrap align-items-center gap-3">
          {filterOptions.map(option => (
            <div
              key={option.id}
              className={`badge rounded-pill px-4 py-2 ${filter === option.id ? 'bg-dark text-white' : 'bg-light text-dark border'}`}
              style={{ cursor: 'pointer', fontSize: '1rem' }}
              onClick={() => setFilter(option.id)}
            >
              {option.label}
            </div>
          ))}
          <input
            type="text"
            className="form-control ms-2"
            style={{ maxWidth: 250, borderRadius: '30px', padding: '8px 16px', fontSize: '1rem' }}
            placeholder="🔍 Rechercher un contributeur"
            value={contributorFilter}
            onChange={(e) => setContributorFilter(e.target.value)}
          />
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="toggleView"
              checked={viewMode === 'list'}
              onChange={() => setViewMode(viewMode === 'cards' ? 'list' : 'cards')}
            />
            <label className="form-check-label" htmlFor="toggleView">
              {viewMode === 'cards' ? '🧩 Carte' : '📋 Liste'}
            </label>
          </div>
        </div>
        <div></div>
      </div>

      <div className="flex-grow-1 p-4">
        {viewMode === 'cards' ? (
          <div className="row g-4">
            {filteredMedia.map((media, index) => {
              const contributorUsername = media.contributor || 'unknown';
              const profileLink = `/users/${contributorUsername}`;
              return (
                <div key={index} className="col-sm-6 col-md-4 col-lg-3">
                  <div className="card h-100 shadow-sm">
                    {getMediaType(media.file_path || media.location) === 'image' ? (
                      <img src={`https://www.weavevo.com/uploads/${media.file_path || media.location}`} className="card-img-top" alt={media.title} />
                    ) : (
                      <video src={`https://www.weavevo.com/uploads/${media.file_path || media.location}`} className="card-img-top" controls />
                    )}
                    <div className="card-body">
                      <h5 className="card-title">{media.title}</h5>
                      <div className="text-muted small">
                         <Link to={profileLink} className="text-decoration-none fw-medium">
                          {media.contributor}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Titre</th>
                  <th>Contributeur</th>
                  <th>Type</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredMedia.map((media, index) => {
                  const contributorUsername = media.contributor || 'unknown';
                  const profileLink = `/users/${contributorUsername}`;
                  return (
                    <tr key={index}>
                      <td>{media.title}</td>
                      <td>
                        <Link to={profileLink} className="text-decoration-none">
                          {media.contributor}
                        </Link>
                      </td>
                      <td>{getMediaType(media.file_path || media.location)}</td>
                      <td>
                        <button className="btn btn-sm btn-primary" onClick={() => generateDoc(media)}>📄 Générer Doc</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default Admin;
